import { isValidLatitude, isValidLongitude } from '@gorila-shared-ui/components';
import { FixedMarker, FixedMarkerOverrides } from 'baseui/map-marker';
import { memo } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { pathState } from '../../../storage/reports';

function PathMarkers() {
  const path = useRecoilValue(pathState);

  const fixedMarkerOverrides: FixedMarkerOverrides = {
    Root: {
      style: () => ({
        transform: `translateY(-50%)`,
      }),
    },
  };

  if (!path?.startPoint || !path.endPoint) return null;

  const {
    startPoint: { coordinates: startCoords },
    endPoint: { coordinates: endCoords },
  } = path;

  if (!(startCoords.length === 2) || !(endCoords.length === 2)) return null;

  const [startLng, startLat] = startCoords;
  const [endLng, endLat] = endCoords;

  if (!startLng || !startLat || !endLng || !endLat) return null;

  if (
    !isValidLongitude(startLng) ||
    !isValidLongitude(endLng) ||
    !isValidLatitude(startLat) ||
    !isValidLatitude(endLat)
  ) {
    return null;
  }

  return (
    <>
      <Marker
        longitude={startLng}
        latitude={startLat}
      >
        <FixedMarker
          label="Inicio"
          size="small"
          overrides={fixedMarkerOverrides}
        />
      </Marker>
      <Marker
        longitude={endLng}
        latitude={endLat}
      >
        <FixedMarker
          label="Fin"
          size="small"
          overrides={fixedMarkerOverrides}
        />
      </Marker>
    </>
  );
}

export default memo(PathMarkers);
